// extracted by mini-css-extract-plugin
export default {"iframeContainer":"token-fallback_iframeContainer__FEdyC","spinnerOverlay":"token-fallback_spinnerOverlay__CL0qZ","emptyState":"token-fallback_emptyState__WoO-g"};